<article class="history">
  <header class="header">
    <div class="header__text-container">
      <h3 class="header__title">
        {{ "dialogs.certificateHistory.title" | translate }}
      </h3>
      <span class="header__subtitle">{{
        "dialogs.certificateHistory.subtitle" | translate
      }}</span>
    </div>
    <button class="close-btn" [mat-dialog-close]="false" type="button"></button>
  </header>
  <div
    class="history__main"
    *ngIf="watchCertificateHistory | async as history; else loadingOrError"
  >
    <div class="history__general-info">
      <div class="history__general-info__item">
        <span class="label">{{
          "dialogs.certificateHistory.generalInfo.releaseDate" | translate
        }}</span>
        <span class="text">{{ history.releaseDate | date: dateFormat }}</span>
      </div>
      <div class="history__general-info__item">
        <span class="label">{{
          "dialogs.certificateHistory.generalInfo.minter" | translate
        }}</span>
        <span class="text" [matTooltip]="history.mintedBy.name!">{{
          history.mintedBy.name
        }}</span>
        <a
          href="mailto:{{ history.mintedBy.email }}"
          class="subtext"
          [matTooltip]="history.mintedBy.email!"
          >{{ history.mintedBy.email }}</a
        >
      </div>
      <div class="history__general-info__item">
        <span class="label">{{
          "dialogs.certificateHistory.generalInfo.claimer" | translate
        }}</span>
        <span class="text" [matTooltip]="history.claimedBy.name!">{{
          history.claimedBy.name
        }}</span>
        <a
          href="mailto:{{ history.claimedBy.email }}"
          class="subtext"
          [matTooltip]="history.claimedBy.email!"
          >{{ history.claimedBy.email }}</a
        >
      </div>
      <div class="history__general-info__item">
        <span class="label">{{
          "dialogs.certificateHistory.generalInfo.currentOwner" | translate
        }}</span>
        <span class="text" [matTooltip]="history.owner.name!">{{
          history.owner.name
        }}</span>
        <a
          href="mailto:{{ history.owner.email }}"
          class="subtext"
          [matTooltip]="history.owner.email!"
          >{{ history.owner.email }}</a
        >
      </div>
    </div>
    <ul class="history__entries">
      <li *ngFor="let entry of history.transfers" class="entry">
        <div class="entry__date-container">
          <span class="entry__date text">{{
            entry.timestamp | date: dateFormat
          }}</span>
        </div>
        <div class="entry__description">
          <ng-container
            [ngTemplateOutlet]="peerInfo"
            [ngTemplateOutletContext]="{
              user:
                entry.type !== CertificateTransferOperation.Send
                  ? entry.receiver
                  : entry.sender
            }"
          ></ng-container>
          <div>
            <span
              *ngIf="entry.type !== CertificateTransferOperation.Send"
              class="subtext"
            >
              {{ "dialogs.certificateHistory.entry.became" | translate }}
            </span>
            <em
              class="emphasised"
              *ngIf="entry.type === CertificateTransferOperation.Minted"
            >
              {{ "dialogs.certificateHistory.entry.minter" | translate }}
            </em>
            <em
              class="emphasised"
              *ngIf="entry.type === CertificateTransferOperation.Claimed"
            >
              {{ "dialogs.certificateHistory.entry.claimer" | translate }}
            </em>
            <span
              *ngIf="entry.type === CertificateTransferOperation.Send"
              class="subtext"
            >
              {{ "dialogs.certificateHistory.entry.sentTo" | translate }}
            </span>
          </div>
          <ng-container
            *ngIf="entry.type === CertificateTransferOperation.Send"
            [ngTemplateOutlet]="peerInfo"
            [ngTemplateOutletContext]="{ user: entry.receiver }"
          ></ng-container>
        </div>
      </li>
    </ul>
  </div>
</article>

<ng-template #peerInfo let-user="user">
  <div class="entry__description__user">
    <img
      class="entry__description__user__image"
      [src]="getImageURL(user.image) ?? 'assets/img/no-avatar.svg'"
      #image
      (error)="image.src = 'assets/img/no-avatar.svg'"
      alt="{{ user.name }} profile picture"
    />
    <div class="entry__description__user__info">
      <span class="text" [matTooltip]="user.name">{{ user.name }}</span>
      <a
        href="mailto:{{ user.email }}"
        class="subtext"
        [matTooltip]="user.email"
        >{{ user.email }}</a
      >
      <span
        class="subtext pointer"
        matTooltip="Click to copy public key"
        (click)="copyText(user.pubKey)"
        >{{ user.pubKey }}</span
      >
    </div>
  </div>
</ng-template>

<ng-template #loadingOrError>
  <div class="place-items-center" *ngIf="isLoading; else error">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
</ng-template>
<ng-template #error>
  <div class="place-items-center">
    <span class="error-text">{{
      "dialogs.certificateHistory.loadingError" | translate
    }}</span>
  </div>
</ng-template>
